var React = require('react');

function CategoryList (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M166.78-140.78q-44.3 0-75.15-30.85-30.85-30.85-30.85-75.15v-466.44q0-44.3 30.85-75.15 30.85-30.85 75.15-30.85h224.74L480-730.74h313.22q44.3 0 75.15 30.85 30.85 30.85 30.85 75.15v377.96q0 44.3-30.85 75.15-30.85 30.85-75.15 30.85H166.78Zm0-106h626.44v-377.96H436.26l-88.48-88.48h-181v466.44Zm0 0v-466.44 466.44Z"}));
}

CategoryList.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = CategoryList;

CategoryList.default = CategoryList;
